<template>
  <div>
    <div class="user-warp">
      <el-form :model="userInfo" label-width="100px">
        <el-form-item label="姓">
          <el-input
            v-if="showBtn"
            v-model="userInfo.familyName"
            placeholder="姓"
          ></el-input>
          <template v-else>{{ userInfo.familyName }}</template>
        </el-form-item>
        <el-form-item label="名">
          <el-input
            v-if="showBtn"
            v-model="userInfo.firstName"
            placeholder="真实姓名"
          ></el-input>
          <template v-else>{{ userInfo.firstName }}</template>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input
            v-if="showBtn"
            v-model="userInfo.identityCard"
            placeholder="身份证号"
          ></el-input>
          <template v-else>{{ userInfo.identityCard }}</template>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-if="showBtn" v-model="userInfo.gender">
            <el-radio :label="10901">男</el-radio>
            <el-radio :label="10902">女</el-radio>
          </el-radio-group>
          <template v-else>{{
            userInfo.gender == 10901 ? "男" : "女"
          }}</template>
        </el-form-item>
        <el-form-item label="出生日期">
          <el-date-picker
            v-if="showBtn"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            v-model="userInfo.birthday"
            class="form-item-info"
            :picker-options="pickerOptions0"
          ></el-date-picker>
          <template v-else>{{ userInfo.birthday }}</template>
        </el-form-item>
        <!-- <el-form-item label="城市">
          <el-input
            v-if="showBtn"
            v-model="userInfo.cityName"
            placeholder="城市"
          ></el-input>
          <template v-else>{{ userInfo.cityName || "暂未填写" }}</template>
        </el-form-item>
        <el-form-item label="所属医院">
          <el-input
            v-if="showBtn"
            v-model="userInfo.hospitalName"
            placeholder="所属医院"
          ></el-input>
          <template v-else>{{ userInfo.hospitalName || "暂未填写" }}</template>
        </el-form-item>
        <el-form-item label="所属科室">
          <el-input
            v-if="showBtn"
            v-model="userInfo.departmentName"
            placeholder="所属科室"
          ></el-input>
          <template v-else>{{
            userInfo.departmentName || "暂未填写"
          }}</template>
        </el-form-item> -->
        <el-form-item
          class="el-form-item-info"
          label="选择城市"
          prop="provinceId"
        >
          <div class="block">
            <el-select
              v-model="userInfo.provinceId"
              placeholder="请选择城市"
              @change="handleChange"
              :disabled="!showBtn"
            >
              <el-option
                v-for="item in cityList"
                :key="item.areaId"
                :label="item.mername"
                :value="item.areaId"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item
          class="el-form-item-info"
          label="所属医院"
          prop="hospitalId"
        >
          <el-select
            class="form-item-info"
            v-model="userInfo.hospitalId"
            filterable
            placeholder="请选择所属医院"
            no-data-text="请选择所属医院"
            @change="getDepartment"
            :disabled="!showBtn"
          >
            <el-option
              v-for="(item, index) in hospitalList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="el-form-item-info"
          label="所属科室"
          prop="departmentName"
        >
          <!-- <el-select class="form-item-info" v-model="userInfo.departmentId" filterable placeholder="请选择所属科室" no-data-text="请选择所属科室">
        <el-option v-for="(item, index) in departmentList" :key="index" :label="item.name" :value="item.id"></el-option>
      </el-select> -->
          <el-input
            v-model="userInfo.departmentName"
            @focus="departmentResult = true"
            placeholder="请选择科室"
            :disabled="!showBtn"
          >
          </el-input>
        </el-form-item>

        <el-form-item v-show="!showBtn">
          <el-button @click="editForm('userInfo')">修改</el-button>
        </el-form-item>
        <el-form-item v-show="showBtn">
          <el-button type="primary" @click="savePharmcistById('userInfo')"
            >保存</el-button
          >
        </el-form-item>
        <el-dialog :visible.sync="departmentResult" width="40%" center>
          <DepartmentList @on_disease_code="on_disease_code" />
        </el-dialog>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  getPharmcistById,
  savePharmcistById,
  getHospital,
  getCityList,
} from "@/api";
import DepartmentList from "@/components/departmentList/DepartmentList.vue";
export default {
  components: {
    DepartmentList,
  },
  name: "userInfo",
  data() {
    return {
      userInfo: {},
      pickerOptions0: {
        // elementUI不能选择超过当天的日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
      showBtn: false, // 显示保存按钮
      cityList: [],
      hospitalList: [],
      cityList: [],
      departmentResult: false,
    };
  },
  created() {
    this.readyCityList();
    this.getPharmcistById();
  },
  methods: {
    // 获取药师信息
    async getPharmcistById() {
      const { code, data } = await getPharmcistById();
      if (code == 1) this.userInfo = data.pharmacist;
      this.readyHospital(this.userInfo.provinceId);
    },
    // 修改药师信息
    async editForm() {
      this.showBtn = !this.showBtn;
    },
    // 保存
    async savePharmcistById() {
      const { code, data } = await savePharmcistById(this.userInfo);
      if (code === 1) {
        this.getPharmcistById();
        this.showBtn = !this.showBtn;
      }
    },
    //城市点击方法
    handleChange(value) {
      console.log(value);
      this.userInfo.regionId = value;
      this.userInfo.hospitalId = "";
      this.userInfo.departmentId = "";
      this.readyHospital(value);
    },
    /**
     * 医院点击
     */
    getDepartment() {
      const that = this;
      let hid = that.userInfo.hospitalId;
      // this.readyDepartment(hid);
    },
    /**
     * @desc 获取所属城市
     */
    async readyCityList() {
      try {
        let res = await getCityList({});
        if (res.code) this.cityList = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 获取所属医院
     */
    async readyHospital(provinceId) {
      if (!provinceId) return;
      try {
        const that = this;
        const params = {
          provinceId: provinceId,
          cityId: "",
          districtId: "",
        };
        let res = await getHospital(params);
        if (res.code) {
          console.log(res);
          this.hospitalList = res.data;
          if (that.userInfo.hospitalId == "") {
            that.userInfo.hospitalId =
              that.hospitalList.length > 0 ? that.hospitalList[0].id : null;
          }
          if (this.hospitalList.length == "") {
            //当更换城市后所属科室设为空，重新选择
            this.userInfo.departmentId = "";
          }
          // this.readyDepartment(this.userInfo.hospitalId);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    on_disease_code(data, type) {
      this.departmentResult = type;
      this.userInfo.departmentId = data.id;
      this.userInfo.departmentName = data.name;
    },
  },
};
</script>
<style lang="scss" scoped>
.user-warp {
  width: 40%;
}
</style>
